module.exports = __webpack_public_path__ + "static/MunchMuseum-b0728ecf4580b7d504e07935fd3f5d89.png";